module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/admin/icons/cart-fbb24a7fc7aa435e4d44098965bf36f0.svg&quot;;"